import enFlag from '@/assets/flags/en.svg';
import kzFlag from '@/assets/flags/kz.svg';
import ruFlag from '@/assets/flags/ru.svg';
import { useI18n } from '@/hooks/useI18n';
import { locales } from '@/i18n';
import type { Locale } from '@/types';

const flags: Record<Locale, string> = { kz: kzFlag, ru: ruFlag, en: enFlag };

export const LanguageSwitcher = () => {
  const { locale, setLocale, t } = useI18n();

  return (
    <div className="langs" role="group" aria-label={t('a11y.language')}>
      {locales.map((code) => (
        <button
          key={code}
          type="button"
          className="flag"
          aria-pressed={locale === code}
          onClick={() => setLocale(code)}
        >
          <img src={flags[code]} alt="" width={18} height={18} />
          {code.toUpperCase()}
        </button>
      ))}
    </div>
  );
};
